import * as React from "react";

function TextArea(props) {
  const {
    label,
    placeholder,
    handleChange,
    key_name,
    style,
    disab,
    labelStyle,
    validation,
    submit,
    mandatory,
  } = props;
  const [error, setError] = React.useState(false);

  React.useEffect(() => {
    if (validation === "required") {
      setError(!props[key_name] || props[key_name]?.trim().length === 0);
      // console.log(props[key_name]);
    }
  }, [submit]);
  return (
    <div>
      <label className={labelStyle ? labelStyle : "label"}>
        {label} {mandatory && <span style={{ color: "red" }}>*</span>}
      </label>
      <textarea
        className={style ? style : "input-style-area"}
        aria-label="Demo input"
        rows={4}
        style={{ border: error && submit ? "1px solid red" : "" }}
        placeholder={placeholder}
        value={props[key_name]}
        name={key_name}
        onChange={handleChange}
        disabled={disab}
      />
    </div>
  );
}
export default React.memo(TextArea);
